<template>
  <div class="input-number">
    <input v-if="!disabled"
      ref="input"
      class="input input--text-right"
      :value="localValue"
      @input="handleInput($event.target.value)"
      @change="handleChange"
    >
    <input v-else
      class="input input--text-right input--disabled"
      :value="localValue"
      disabled
    >
  </div>
</template>

<script>
export default {
  name: 'VInputNumber',

  props: {
    placeholder: {
      type: String,
      default: 'Введите число'
    },

    value: {
      type: [Number, String],
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      localValue: this.value
    }
  },

  watch: {
    value(value) {
      this.localValue = value
    }
  },

  methods: {
    handleInput(value) {
      const result = this.filterValue(value)
      this.localValue = result
      this.$emit('input', result)
    },

    handleChange() {
      this.$emit('change', this.localValue)
    },

    filterValue(value) {
      const notDigits = /[^\d]/g
      const digitsValue = value.replace(notDigits, '')
      return Number(digitsValue)
    }
  }
}
</script>

<style>
.input-number {
  display: inline-block;
  max-width: 96px;
}
</style>
